import axios from "axios";
import React, { useEffect ,useRef,useState} from "react";
import { Spinner } from "react-activity";
import base_url from "../../../base_url";
import {localStorageUserKey} from '../../../local_storage_vars';
import { smartStorage } from "../../../smart_storage";

export default function OfferAccepted({socket,detectPageChange}){
    const [is_order_created,setOrderCreated] = useState(false);
    const [isLoading,setisLoading] = useState(true);
    const shouldLog  = useRef(true);

    console.log("abc1");

    const create_order = async () => {
        console.log("abc3");
        socket.disconnect()
        const params = new URLSearchParams(window.location.search);
        const of_id = params.get('of_id')
        const payment_method_id = params.get('payment_method_id')
        
        const paymentId = params.get('token')

        console.log("abc4");
        try {
            if (is_order_created) { return false }
            const user = smartStorage.get(localStorageUserKey);
            const apiUrl = `${base_url}/apis/order/create-order`;
            console.log(`4.fe-offerAccepted:::>>>socket: ${socket.id}, user: ${user} `);
            await axios.post(
                apiUrl,
                {
                    offer_id: of_id,
                    payment_method_id: payment_method_id,
                    paymentId: paymentId,       
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        "x-api-key": process.env.REACT_APP_API_KEY,
                        "authorization": user,
                    },
                }
            )
            .then((response) => {
                console.log("abc5");
                if (response.status === 200) {
                    try {
                       setTimeout(() => {                        
                            setOrderCreated(true)
                            setisLoading(false)
                            console.log(`6.fe-offerAccepted:::>>>socket: ${socket.id} , offer_id: ${of_id}`);
                           // window.close(); //closing window after 3 seconds
                            socket.emit('offer_accepted',{
                                offer_id:of_id
                            })
                       }, 500);
                    }
                    catch (err) {
                        console.log("Error in offer accepted page", err); 
                        setOrderCreated(true);
                        setisLoading(false);
                    }
                } else {
                    setOrderCreated(false);
                    setisLoading(false);
                }
            })
            .catch((err) => {
                setOrderCreated(false);
                setisLoading(false);
            });
        } catch (err) {
            setOrderCreated(false);
            setisLoading(false);
        }
    }


    useEffect(() => {
    try {
        console.log("abc2");
        socket.connect();
        console.log(`3.fe-offerAccepted:::>>>socket ${socket.id}`);
        if(shouldLog.current){
            shouldLog.current = false
            detectPageChange(window.location.pathname)

            create_order();
        }

    } catch (err) {
        console.log("Error in offer accepted page", err); 
    }
}, [])

    
    if(isLoading == false){
        if(is_order_created){
            return (
                <center className="container border p-4" style={{borderRadius:10}}>
                    <div className="row">
                        <div className="col-md-12">
                            <h1>Order Created Successfully</h1>

                            <button className="btn btn-primary" onClick={()=>window.location='/orders'}>Go to orders </button>

                        </div>
                    </div>
                </center>
          //window.close();      
            )
            
        }else{
            return (
                <center className="container border p-4" style={{borderRadius:10}}>
                    <div className="row">
                        <div className="col-md-12">
                        <i className="fa fa-globe fa-5x text-primary"></i>
                            <h1 >Required Operation Failed</h1>
                            <br />
                            <button className="btn btn-primary" onClick={()=>window.location='/orders'}>Go to orders</button>

                        </div>
                    </div>
                </center>
            )
        }
      
    }else{
       return <center>
            <Spinner size={30} color={'skyblue'} style={{marginTop:20}}/>
       </center>
    }
   
}